import './../Filter/Filter.scss';
import Component from './BuyerListFilter.js';
export default Component;